import React, { useContext, useEffect } from "react";
import "./Our_process.css";
import Common_heading from "../../common_components/common_heading/Common_heading";
import Our_process_card from "./our_process_card/Our_process_card";
import {
  GetAllMeetOurTeam,
  GetAllOurProcess,
} from "../../features/website/Slice";
import { useDispatch, useSelector } from "react-redux";
import { IDS } from "../../../utils/IDS";
import { Context } from "../../../utils/context";

function Our_process() {
  const dispatch = useDispatch();

  const OurProcess = useSelector(
    (state) => state?.website?.GetSuccessSpeaks?.all_our_process,
  );

  const { language, setLanguage } = useContext(Context);

  console.log(OurProcess, "OurProcess");

  const loadOurStory = async () => {
    await dispatch(GetAllOurProcess({ language }));
  };

  useEffect(() => {
    loadOurStory();
  }, [dispatch, language]);

  console.log(
    IDS?.IMG_URL + OurProcess?.data?.[0]?.AboutUsOurProcess?.video,
    "OurProcess?.data?.[0]?.video",
  );

  return (
    <>
      <section className="Our_process">
        <div className="container">
          <Common_heading headingText="Our Process" />

          <div className="proccess_section_holder">
            <div className="row">
              {OurProcess?.data?.[0] && (
                <div className="col-md-3 col-sm-3 col-6 card_1">
                  <Our_process_card
                    vdo_Src={
                      IDS?.IMG_URL + OurProcess.data[0].AboutUsOurProcess?.video
                    }
                    number={OurProcess.data[0].AboutUsOurProcess?.id}
                    headingText={OurProcess.data[0].name}
                    desc_text={OurProcess.data[0].sub_title}
                  />
                </div>
              )}
              {OurProcess?.data?.[1] && (
                <div className="col-md-3 col-sm-3 col-6 card_2">
                  <Our_process_card
                    vdo_Src={
                      IDS?.IMG_URL +
                      OurProcess?.data?.[1]?.AboutUsOurProcess?.video
                    }
                    number={OurProcess?.data?.[1]?.AboutUsOurProcess?.id}
                    headingText={OurProcess?.data?.[1]?.name}
                    desc_text={OurProcess?.data?.[1]?.sub_title}
                  />
                </div>
              )}
              {OurProcess?.data?.[2] && (
                <div className="col-md-3 col-sm-3 col-6 card_3">
                  <Our_process_card
                    vdo_Src={
                      IDS?.IMG_URL +
                      OurProcess?.data?.[2]?.AboutUsOurProcess?.video
                    }
                    number={OurProcess?.data?.[2]?.AboutUsOurProcess?.id}
                    headingText={OurProcess?.data?.[2]?.name}
                    desc_text={OurProcess?.data?.[2]?.sub_title}
                  />
                </div>
              )}
              {OurProcess?.data?.[3] && (
                <div className="col-md-3 col-sm-3 col-6 card_4">
                  <Our_process_card
                    vdo_Src={
                      IDS?.IMG_URL +
                      OurProcess?.data?.[3]?.AboutUsOurProcess?.video
                    }
                    number={OurProcess?.data?.[3]?.AboutUsOurProcess?.id}
                    headingText={OurProcess?.data?.[3]?.name}
                    desc_text={OurProcess?.data?.[3]?.sub_title}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Our_process;
